function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "stack-open",
  d: "M6.27,6.45h12.3a.367.367,0,0,0,.366-.373,1.1,1.1,0,0,0-.219-.644A1.082,1.082,0,0,0,17.85,5H7.039a1.142,1.142,0,0,0-.821.324A1.073,1.073,0,0,0,5.9,6.08.368.368,0,0,0,6.27,6.45ZM4.645,9.086a.362.362,0,0,0,.349.263H19.851a.362.362,0,0,0,.349-.263l.138-.483a1.131,1.131,0,0,0-.085-.873,1.086,1.086,0,0,0-.952-.556H5.588a1.143,1.143,0,0,0-.819.32A1.082,1.082,0,0,0,4.494,8.56l.15.526ZM21.8,11.459l-2.49,8.7a1.1,1.1,0,0,1-1.049.789H6.579a1.093,1.093,0,0,1-1.047-.789l-2.49-8.7a1.088,1.088,0,0,1,1.047-1.386H20.755A1.088,1.088,0,0,1,21.8,11.459Z",
  transform: "translate(-2.999 -5)",
  fill: "#323232"
});

function SvgIcHaitAnyTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.846,
    height: 15.947,
    viewBox: "0 0 18.846 15.947",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHaitAnyTime);
export default ForwardRef;